<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
          <div class='col-lg-12' style='padding:0px'>
            <table width='100%' class='table  table-bordered ' >
                  <thead>
                    <tr>
                        <th style='text-align: center'>الصنف</th>
                        <th style='text-align: center'>آخر تغيير</th>
                        <th style='text-align: center'>مدة التغيير</th>
                        <th style='text-align: center'>التغيير التالى</th>
                        <th style='text-align: center'>النوع</th>
                        <th style='text-align: center'>الصيانة</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for='record in records' :key='record.id'>
                        <td style="padding:2px" align='center'>{{record.item}}</td>
                        <td style="padding:2px" align='center'>{{record.last_change}}</td>
                        <td style="padding:2px" align='center'>{{record.change}}</td>
                        <td style="padding:2px" align='center'>{{record.next_change}}</td>
                        <td style="padding:2px" align='center'>{{record.type_str}}</td>
                        <td style="padding:2px" align='center'>{{record.type}}</td>
                      </tr>
                  </tbody>
              </table>
              <!-- /.table-responsive -->
          <!-- /.col-lg-12 -->
          </div>
       </div>
    <!-- /.container-fluid -->
</div>
</template>
<script>
import API from '@/store/api'
export default {
  name: 'MaintenanceSchedule',
  data () {
    return {
      isLoadingData: false,
      records: []
    }
  },
  methods: {
    // =====================================================
    async pageLoad (id) {
      this.records = []
      this.isLoadingData = true
      try {
        const data = await API.getNextMaintenance({
          id: id
        })
        this.records = data
      } catch (err) {
        this.records = []
      }
      this.isLoadingData = false
    }
    // tabSelected () {
    //   this.records = ''
    //   this.isLoadingData = true
    //   axios.post(this.$apiURL + 'get-next-maintenance', {
    //     token: localStorage.getItem('token'),
    //     contract_id: this.$store.state.customerData.contract_id
    //   })
    //     .then(res => {
    //       this.records = res.data
    //       this.isLoadingData = false
    //     })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/MaintenanceSchedule.vue